import ProcedureDTO from '@src/adapters/dto/procedure/ProcedureDTO';
import useApi, { ApiOptions } from '../base/useApi';

interface Params {
  procedure: ProcedureDTO;
}

interface Result {
  procedure: ProcedureDTO;
}

const options: ApiOptions = {
  method: 'post',
  urlPath: '/procedure',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};
export const useCreateProcedure = (params?: Params) => {
  options.lazy = false;
  return useApi<Params, Result>(options, params);
};

export const useCreateProcedureLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useCreateProcedure;
